import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { withTranslation } from "react-i18next";
import HeaderMenu from "./HeaderMenu";
import IPosModal from "../../IPosModal";
import { getLanguageById } from "../../helpers/language";
import LanguageFlag from "../../components/LanguageFlag";
import { loadRestaurant } from "../../redux/actions/baseActions";
import './HeaderNew.scss';


const HeaderNew = ({
  branchInfo,
  currentDeliveryType,
  currentLanguageId,
  empty,
  shorHeader = false,
  t,
}) => {
  const history = useHistory();

  const openBranchInfo = () => {
    IPosModal.branchInfo({
      branchInfo: branchInfo,
      t: t,
      onOk: () => {},
    });
  };
  const goToHome = () => {
    if (shorHeader) {
      return;
    }
    IPosModal.confirmation({
      title: t("dialogs.redirect_to_home_title"),
      message: t("dialogs.redirect_to_home_description"),
      okButtonText: t("buttons.ok"),
      cancelButtonText: t("buttons.cancel"),
      onOk: () => {
        const lang = getLanguageById(currentLanguageId);
        if (branchInfo && branchInfo.branch_guid_code) {
          history.push(`/${branchInfo.branch_guid_code}/type?lang=${lang}`);
        } else {
          history.push("/");
        }

        window.location.reload();
      },
      onClose: () => {
        return;
      },
    });
  };
  return (
    <header className="shop-header">
      {!shorHeader && (
        <HeaderMenu t={t} />
      )}
      {!shorHeader && (
        <LanguageFlag/>
      )}
    </header>
  );
};

const mapStateToProps = (state) => {
  const { branchInfo, currentDeliveryType, currentLanguageId } = state;

  return {
    branchInfo,
    currentDeliveryType,
    currentLanguageId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ loadRestaurant }, dispatch);

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(HeaderNew));
